import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import Cloudinary from "cloudinary-vue";
import JsonExcel from 'vue-json-excel'
//require("./assets/css/main.scss");
import {VueMeta} from 'vue-meta'
Vue.config.productionTip = false
Vue.component("downloadExcel", JsonExcel);
Vue.use(Cloudinary, {
  configuration: { cloudName: "demo" },
  
});

Vue.use(VueToast, {
  position: "bottom-right"
});
/*Vue.use(VueMeta,{
  keyName: 'jose santiago',
  attribute: 'Portafolio web, José Santiago',
  ssrAttribute: 'data-vue-meta-server -rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})*/
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
